export const navigationTranslations = {
  NAVIGATION_OPERATOR_BUTTON_TEXT: 'Join as operator!'
}
